import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import AuthGuard from './auth/AuthGuard';
// import { authRoles } from "./auth/authRoles";

import Loadable from './components/Loadable';
import MatxLayout from './components/MatxLayout/MatxLayout';
const NotFound = Loadable(lazy(() => import('../app/views/sessions/NotFound')));
const JwtLogin = Loadable(lazy(() => import('../app/views/sessions/JwtLogin')));
const Dashboard = Loadable(lazy(() => import('../app/views/dashboard/dashboard')));
const UserMaster = Loadable(lazy(() => import('../app/views/userMaster/user-master')));
const SalesRepMaster = Loadable(lazy(() => import('../app/views/salesRepMaster/sales-repmaster')));
const PartyMaster = Loadable(lazy(() => import('../app/views/partyMaster/partyMaster')));
const VisitHistory = Loadable(lazy(() => import('./views/visitHistory/visit-history')));
const routes = [
    {
        element: (
            <AuthGuard>
                <MatxLayout />
            </AuthGuard>
        ),
        // children: filteredNavigations?.length > 0 ? filteredNavigations : const_navigations
        children: [
            { path: '/dashboard', element: <Dashboard /> },
            { path: '/user-master', element: <UserMaster /> },
            { path: '/sales-rep-master', element: <SalesRepMaster /> },
            { path: '/party-master', element: <PartyMaster /> },
            { path: '/visit-history', element: <VisitHistory /> },
        ],
    },
    { path: '/', element: <Navigate to="/session/signin" /> },
    { path: '*', element: <NotFound /> },
    { path: '/session/signin', element: <JwtLogin /> },
];

export default routes;
